import axios from "axios";
import { SuperAdminURL } from "../../../../config/UrlEndPoint";

export const URL = `${SuperAdminURL}library`;

//  * FIND LIBRARY FOLDER
export function findlibraryFolder(queryParams) {
  return axios.post(`${URL}/find_folder`, queryParams);
}
// * CREATE LIBRARY FOLDER
export function createLibraryFolder(payload) {
  return axios.post(`${URL}/create_folder`, payload);
}
// * UPDATE LIBRARY FOLDER
export function updateLibraryFolder(payload) {
  return axios.put(`${URL}/update_folder`, payload);
}
// * DELETE FOLDER
export function deleteLibraryFolder(id) {
  return axios.delete(`${URL}/delete_folder/${id}`);
}

//  * FIND LIBRARY FILE
export function findlibraryFile(queryParams) {
  return axios.post(`${URL}/find_file`, queryParams);
}
// * UPLOAD FILE
export function createLibraryFile(payload) {
  return axios.post(`${URL}/create_file`, payload);
}
// * DELETE FILE
export function deleteLibraryFile(id) {
  return axios.delete(`${URL}/delete_file/${id}`);
}
